import { SITE_URL } from "./site";

/*
 * Which legal documents a new account is bound by, and where they live.
 *
 * They are pages on the marketing site rather than in this app, so the origin
 * comes from `site.ts` — see the note there for why it defaults to localhost
 * rather than to production.
 */

/**
 * The four documents the Terms name.
 *
 * Not a shorter list, and not a longer one. §1 of the Terms says that by
 * creating an account you "agree to be bound by this Agreement, our Acceptable
 * Use Policy, our Privacy Policy, and our Data Processing Agreement" — so these
 * are exactly the things a new account is agreeing to, and naming three of them
 * would understate it while adding the DMCA policy would overstate it.
 *
 * If that sentence in the Terms changes, this list changes with it.
 */
export const LEGAL_DOCUMENTS = [
  { key: "terms", href: `${SITE_URL}/legal/terms` },
  { key: "acceptableUse", href: `${SITE_URL}/legal/acceptable-use` },
  { key: "privacy", href: `${SITE_URL}/legal/privacy` },
  { key: "dpa", href: `${SITE_URL}/legal/dpa` },
] as const;
